import {
    OPERATOR_LIST_START,
    OPERATOR_LIST_SUCCESS,
    OPERATOR_LIST_ERROR,
} from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
};
  
export default function operatorReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case OPERATOR_LIST_START:
        return {
          ...state,
          loading: true,
        };
      case OPERATOR_LIST_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case OPERATOR_LIST_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  